import React, { useState } from 'react'
import { List } from 'immutable'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import Button, { TYPES } from '../../Button/index'
import Icon, { ICON_TYPES } from '../../Icon.v2/index'
import PlanValueProp from '../../PlanValueProp/index'

const INITIAL_VISIBLE_PROPS = 2

function PlanValueProps (props) {
  const {
    plan,
    staticText,
  } = props
  const allValueProps = plan.get('valueProps', List())
  const [isExpanded, setIsExpanded] = useState(false)
  const visibleValueProps = isExpanded
    ? allValueProps : allValueProps.slice(0, INITIAL_VISIBLE_PROPS)
  const hasMoreProps = allValueProps.size > INITIAL_VISIBLE_PROPS

  const handleToggleExpand = () => {
    setIsExpanded((prev) => !prev)
  }

  if (!hasMoreProps) {
    return (
      <>
        {allValueProps.map((valueProp, index) => (
          <div className="account-cancel-special-offer__plan-value-prop" key={`value-prop-${index}`}>
            <Icon type={ICON_TYPES.CHECK} className="account-cancel-special-offer__plan-value-prop-icon" />
            <PlanValueProp
              valueProp={valueProp}
              className="account-cancel-special-offer__plan-value-prop-text"
            />
          </div>
        ))}
      </>
    )
  }

  const click = staticText.getIn(['data', 'click'], '')
  const formattedClick = `<span class="account-cancel-special-offer__plan-value-props-see-more-underline">${click}</span>`
  const clickToSeeMore = staticText.getIn(['data', 'clickToSeeMore'], '').replace(/\$\{click\}/g, formattedClick)
  const clickToSeeLess = staticText.getIn(['data', 'clickToSeeLess'], '').replace(/\$\{click\}/g, formattedClick)
  const seeMoreSuffix = isExpanded
    ? clickToSeeLess
    : clickToSeeMore

  return (
    <>
      {visibleValueProps.map((valueProp, index) => {
        const isExpandedProp = index >= INITIAL_VISIBLE_PROPS
        return (
          <div
            className={`account-cancel-special-offer__plan-value-prop${isExpandedProp ? ' account-cancel-special-offer__plan-value-prop--expanded' : ''}`}
            key={`value-prop-${index}`}
          >
            <Icon type={ICON_TYPES.CHECK} className="account-cancel-special-offer__plan-value-prop-icon" />
            <PlanValueProp
              valueProp={valueProp}
              className="account-cancel-special-offer__plan-value-prop-text"
            />
          </div>
        )
      })}
      <div
        className="account-cancel-special-offer__plan-value-props-see-more"
        onClick={handleToggleExpand}
      >
        <span dangerouslySetInnerHTML={{ __html: seeMoreSuffix }} />
      </div>
    </>
  )
}

PlanValueProps.propTypes = {
  plan: ImmutablePropTypes.map.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
}

function SpecialOfferPlanCard (props) {
  const {
    plan,
    onPlanClick,
    staticText,
    isProcessing = false,
  } = props

  const label = plan.get('label')
  const description = plan.get('description')
  const keyModifier = plan.get('keyModifier')
  const labelModifier = plan.get('labelModifier')

  return (
    <div className={`account-cancel-special-offer__plan account-cancel-special-offer__plan--${keyModifier}`}>
      {label && (
        <div className={`account-cancel-special-offer__plan-label account-cancel-special-offer__plan-label--${labelModifier}`}>
          {label}
        </div>
      )}
      <div className="account-cancel-special-offer__plan-top">
        <div className="account-cancel-special-offer__plan-title">{plan.get('title')}</div>
        {description && (
          <div
            className={`account-cancel-special-offer__plan-description account-cancel-special-offer__plan-description--${keyModifier}`}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
        <Button
          type={TYPES.DEFAULT}
          onClick={() => onPlanClick(plan)}
          className={`account-cancel-special-offer__plan-button account-cancel-special-offer__plan-button--${keyModifier}`}
          disabled={isProcessing}
        >
          {isProcessing
            ? staticText.getIn(['data', 'processing'], 'Processing...')
            : staticText.getIn(['data', 'acceptOffer'])}
        </Button>
      </div>
      <div className="account-cancel-special-offer__plan-value-props">
        <PlanValueProps
          plan={plan}
          staticText={staticText}
        />
      </div>
    </div>
  )
}

SpecialOfferPlanCard.propTypes = {
  plan: ImmutablePropTypes.map.isRequired,
  onPlanClick: PropTypes.func.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  isProcessing: PropTypes.bool,
}

export default SpecialOfferPlanCard
